import { gbConstants } from "../_constants";
import { authHeader } from "../_helpers";

export const locationService = {
    getCities,
    getDistricts
};
const cityURL = `${gbConstants.HOST_SERVICE}/v1.1/city`;

function getCities() {
    const requestOptions = {
        mode: "cors",
        method: "GET",
        headers: authHeader()
    };

    return fetch(cityURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            return data.data;
        });
}

function getDistricts(cityId) {
    const requestOptions = {
        mode: "cors",
        method: "GET",
        headers: authHeader()
    };

    return fetch(cityURL + "/" + cityId, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            return data.data;
        });
}



// WEBPACK FOOTER //
// ./src/_services/location.service.js